import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('TreeSelectorPopup', null, { withChildren: true });
